const data = {
	"width": 24,
	"height": 24,
	"hidden": true,
	"body": "<path d=\"M11.157 12a4.573 4.573 0 1 1-9.147 0a4.573 4.573 0 0 1 9.147 0zm10.833 0a4.573 4.573 0 1 1-9.147 0a4.573 4.573 0 0 1 9.147 0z\" fill=\"currentColor\"/>"
};
export default data;
